import {
    ICheckForDuplicatesData,
    IGetAllPhotosForCurrentUserMeta,
    IUserPhoto,
    IUserPhotosResponse
} from '../Stores/UserPhotoStore';
import { ApiService } from '../_services/ApiService';

export enum TagType {
    DATE = 3,
    LOCATION = 4,
    FILENAME = 5
}

export interface IPhotoForServer {
    image: any;
    rotateDegrees: number;
    tags: Partial<Record<keyof typeof TagType, string>>;
    image_thumbnail?: any;
}

export class PhotoPageService extends ApiService {
    protected basePath = 'photo_page';


    public getAllPhotosForCurrentUser(data: IGetAllPhotosForCurrentUserMeta): Promise<IUserPhotosResponse> {
        console.group('getAllPhotosForCurrentUser');
        console.log('data', data);
        console.groupEnd();
        return this.getRequest(data).then(response => {
            return response;
        });
    }

    public checkForDuplicates(data: ICheckForDuplicatesData): Promise<Array<IUserPhoto>> {
        return this.postSubPath('duplicate_check', data).then(response => {
            return response;
        });
    }




}



// WEBPACK FOOTER //
// ./src/Services/PhotoPageService.tsx